import React from 'react';
import { makeStyles, Button } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

export default function BackForwardButton(props) {
    const classes = useStyles();

    let back = <React.Fragment></React.Fragment>
    let forward = <React.Fragment></React.Fragment>    
    let text = "";
    if(props.direction === 'Back'){
        back = <ArrowBackIosIcon className={classes.arrowBack}></ArrowBackIosIcon>
        text = "back"
    }
    if(props.direction === 'forward'){
        forward = <ArrowForwardIosIcon className={classes.arrowForward}></ArrowForwardIosIcon>
        text = "next"
    }

    if(props.textOverride){
        text = props.textOverride
    }

    const action = () => {
        
    }

    return <Button onClick={props.action?() => props.action():action()}>
        {back}
        <div className={classes.text}>
            {text}
        </div>
        {forward}
    </Button>
}

const useStyles = makeStyles({
    arrowBack: {
        color:FlagstoneTheme.palette.primary.main,
        width:"15px",
        height:"15px",
        float:"left"
    },
    text:{
        float:"left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform:"none"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
});